<template>
  <div class="kye-report-echarts-pie" :class="`kye-report-echarts-pie-${code}`">
    <slot name="summary">
      <div v-if="isBt" class="kye-report-echarts-pie_summary" @click="summaryClick">
        <div class="kye-report-echarts-pie_summary-label">{{ summaryData.name }}</div>
        <div class="kye-report-echarts-pie_summary-value">{{ summaryData.value }}</div>
      </div>
    </slot>
    <div class="kye-report-echarts-pie_dom" ref="echartsPie"></div>
    <Legend
      v-if="showLegend"
      :columns="columns"
      :data="data"
      :code="code"
      :colors="colors"
      :hoverCurIndex="hoverCurIndex"
      :propsConfig="propsConfig"
      :echartsConfig="echartsConfig"
      :showTableMode="showTableMode">
    </Legend>
  </div>
</template>

<script>
  import * as echarts from '@kyfe/echarts5'
  import { CreateEchartsConfig, commonProps, extend } from '../common'
  import { merge } from 'lodash'
  import { echartsType } from '../common/basic/pie'
  import { codesConfig, pieCodes } from './config'
  import Legend from './legend.vue'

  export default {
    name: 'kye-form-pie',
    props: extend({
      columns: {
        type: Array,
        default: () => ([])
      },
      option: {
        type: Object,
        default: () => ({})
      },
      propsConfig: {
        type: Object,
        default: () => ({
          label: 'name',
          value: 'value'
        })
      },
      summaryData: {
        type: Object,
        default: () => ({})
      },
      showLegend: {
        type: Boolean,
        default: true
      }
    }, commonProps),
    components: {
      Legend
    },
    data() {
      return {
        echartsInstance: null,
        echartsConfig: {},
        hoverCurIndex: ''
      }
    },
    watch: {
      data() {
        this.renderEcharts()
      },
      summaryData: {
        handler() {
          this.renderEcharts()
        },
        deep: true
      },
      option() {
        this.renderEcharts()
      }
    },
    mounted() {
     this.renderEcharts()
    },
    computed: {
      colors() {
        const { option = {} } = this.echartsConfig
        return option.color || []
      },
      showTableMode() {
        const { code } = this
        return [pieCodes.hxt005, pieCodes.bt005].includes(code) && !!this.columns.length
      },
      isBt() {
        return this.code.includes('Bt')
      }
    },
    methods: {
      renderEcharts() {
        const { autoRender } = this.$props
        if (autoRender) {
          this.init()
        }
      },
      init() {
        this.initEchartsConfig()
        // 为了先渲染指标卡好自动分配高度
        setTimeout(() => {
          this.initEcharts()
        }, 100)
      },
      initEcharts() {
        this.echartsInstance = echarts.init(this.$refs.echartsPie)
        if (this.echartsInstance) {
          const { option } = this.echartsConfig
          this.echartsInstance.setOption(merge(option, this.option), true)
          this.echartsConfig.option = this.echartsInstance.getOption()
          this.echartsInstance.on('mouseover', 'series.pie', this.echartsMouse)
          this.echartsInstance.on('mouseout', 'series.pie', this.echartsMouse)
        }
      },
      initEchartsConfig() {
        const { code, data, summaryData } = this
        this.echartsConfig = new CreateEchartsConfig(echartsType, {
          code,
          data,
          commonConfig: codesConfig[code] || codesConfig[pieCodes.hxt001],
          summaryData,
          tooltipFormatterConfig: this.$props.tooltipFormatterConfig || {},
          propsConfig: this.$props.propsConfig
        })
      },
      getEcharts() {
        return this.echartsInstance
      },
      addEchartsEvent(eventName, callBack) {
        if (!eventName || !callBack) return
        this.echartsInstance.on(eventName, callBack)
      },
      summaryClick() {
        this.$emit('summaryClick', this.summaryData)
      },
      echartsMouse(params) {
        const { event, dataIndex } = params
        if (event.type === 'mouseout') {
          this.hoverCurIndex = ''
        } else {
          this.$nextTick(() => {
            this.hoverCurIndex = dataIndex
          })
        }
      }
    },
    beforeDestroy() {
      if (this.echartsInstance) {
        this.echartsInstance.off('mouseover', this.echartsMouse)
        this.echartsInstance.off('mouseout', this.echartsMouse)
      }
    }
  }
</script>

<style lang="less">
  @size100: 100%;
  .kye-report-echarts-pie{
    width: @size100;
    height: @size100;
    position: relative;
    &-Hxt001, &-Hxt002,  &-Bt001, &-Bt002 {
      display: flex;
      flex-direction: column;
      .kye-report-echarts-pie_dom{
        flex: 1;
        width: @size100;
      }
    }
    &-Hxt003, &-Hxt004, &-Hxt005, &-Bt003, &-Bt004, &-Bt005  {
      display: flex;
      align-items: center;
      flex-wrap: nowrap;
      .kye-report-echarts-pie_dom{
        height: @size100;
        width: @size100;
      }
    }
    &_summary{
      position: absolute;
      top: 12px;
      left: 16px;
      display: flex;
      font-size: 12px;
      align-items: center;
      &-label{
        color: #666666;
      }
      &-value{
        color: #333333;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/public/components/kye-report-form/echarts/pie/index.vue